
import {  Paper} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';

const PitchVideoPopup = ({ data }) => {
    const theme = useTheme();

    return (
        <>
            <Paper sx={{ backgroundColor: theme.palette.background.paper, boxShadow: 3, padding: '10px',  overflowY: "auto", maxHeight: "90vh" }} >
                <h3 style={{ textAlign: 'center' }}>Pitch Video</h3>
                <div>
                <video src={data} controls width={500}>
                <track kind="captions" srcLang="en"/>
                Pitch Video
                </video>
           </div>
            </Paper>
        </>
    );
}

export default PitchVideoPopup;
